import { render, staticRenderFns } from "./OrdersAll.vue?vue&type=template&id=36515994&scoped=true&"
import script from "./OrdersAll.vue?vue&type=script&lang=js&"
export * from "./OrdersAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36515994",
  null
  
)

export default component.exports